import { environment as base } from './environment.base';

export const environment = {
	...base,
	id: 'beta',
	scopes: {
		...base.scopes,
		public: {
			...base.scopes.public,
			hideTextNotApplicableLicensePlate: false
		}
	}
};
